(function () {
  function getDialog() {
    return document.getElementById('addon-upsell-dialog');
  }

  function showModal() {
    const dialog = getDialog();
    if (!dialog || dialog.open) return;
    dialog.showModal();
    dialog.querySelector('#addon-upsell-close')?.focus();
  }

  function hideModal() {
    const dialog = getDialog();
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function addToCart(variantId, button) {
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.id) {
          button.classList.add('is-added');
          const defaultText = button.querySelector('.addon-upsell__btn-default');
          const addedText = button.querySelector('.addon-upsell__btn-added');
          if (defaultText) defaultText.hidden = true;
          if (addedText) addedText.hidden = false;
        } else {
          button.disabled = false;
        }
      })
      .catch(() => {
        button.disabled = false;
      });
  }

  function init() {
    const dialog = getDialog();
    if (!dialog) return;

    // Intercept ONLY a direct user click on the checkout button.
    // - Selector is intentionally narrow: must be a <button> element with
    //   id="checkout" (or name="checkout" type="submit") — this avoids
    //   catching Enter-key form submissions or clicks on unrelated elements.
    // - The '#addon-upsell-dialog' ancestor check prevents re-triggering
    //   from clicks inside our own modal.
    // - btn.disabled guard skips the empty-cart state.
    document.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('#addon-upsell-dialog')) return;

        const btn = e.target.closest(
          'button#checkout, button[name="checkout"][type="submit"]'
        );
        if (!btn || btn.disabled || dialog.open) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        showModal();
      },
      { capture: true }
    );

    // X button — close, stay on cart
    document.getElementById('addon-upsell-close')?.addEventListener('click', hideModal);

    // "No thanks" — go to checkout without adding anything
    document.getElementById('addon-upsell-skip')?.addEventListener('click', function () {
      hideModal();
      goToCheckout();
    });

    // "Checkout →" — go to checkout (items may have been added)
    document.getElementById('addon-upsell-checkout')?.addEventListener('click', function () {
      hideModal();
      goToCheckout();
    });

    // Click on the dialog background (outside the modal box) — close, stay on cart
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) hideModal();
    });

    // Escape key is handled natively by the browser (closes dialog, stays on cart)

    // Add-to-cart buttons inside the modal
    dialog.addEventListener('click', function (e) {
      const addBtn = e.target.closest('.addon-upsell__add-btn');
      if (!addBtn || addBtn.disabled || addBtn.classList.contains('is-added')) return;

      const variantId = addBtn.dataset.variantId;
      if (!variantId) return;

      addToCart(variantId, addBtn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
